import React from 'react';
import { Box, Typography, CircularProgress, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

const WelcomeContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  padding: theme.spacing(3),
  animation: 'fadeIn 0.3s ease-in-out',
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
      transform: 'translateY(20px)'
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)'
    }
  }
}));

const WelcomeCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  textAlign: 'center',
  maxWidth: 500,
  width: '100%',
  borderRadius: 16,
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  background: 'rgba(255, 255, 255, 0.95)',
  backdropFilter: 'blur(10px)',
}));

const Logo = styled('div')(({ theme }) => ({
  fontSize: '2.5rem',
  fontWeight: 'bold',
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(2),
  textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
}));

const WelcomeBanner = () => {
  return (
    <WelcomeContainer data-testid="welcome-banner">
      <WelcomeCard elevation={3}>
        <Logo>🏥 QuantumLeap EMR</Logo>
        
        <Typography 
          variant="h5" 
          component="h1" 
          gutterBottom
          sx={{ 
            fontWeight: 600,
            color: 'text.primary',
            mb: 2
          }}
        >
          Loading...
        </Typography>
        
        <Typography 
          variant="body1" 
          color="text.secondary"
          sx={{ mb: 3, lineHeight: 1.6 }}
        >
          Please wait while we load your profile and facility information.
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
          <CircularProgress size={24} />
          <Typography variant="body2" color="text.secondary">
            Loading...
          </Typography>
        </Box>
        
        <Typography 
          variant="caption" 
          color="text.disabled"
          sx={{ 
            display: 'block', 
            mt: 3,
            fontStyle: 'italic'
          }}
        >
          This should only take a moment
        </Typography>
      </WelcomeCard>
    </WelcomeContainer>
  );
};

export default WelcomeBanner; 